
import Vue from 'vue';
import bus from '@/core/bus';
import { Component } from 'vue-property-decorator';
import { BusConstants, ModalConstants, isModal } from '@/core/constants';
import { UserModule } from '@/store/modules/user/user.store';
import dispatchActionForAllModules from '@/store/initialize.stores';
import { ISignalRClient } from '../../models/website/SignalRClient';
import dateFormat from '@/plugins/filters/dateFormat.filter';
import { BvModalEvent } from 'bootstrap-vue';
import UrlService from '@/services/url/urlHelper.service';
import { NotificationViewObject, VoteSiteViewObject } from '@/types/apiServerContract';
import { ClientMessage, ClientMessageType } from '../messages/types';

@Component
export default class SpaServer extends Vue {
    get isLoggedIn() {
        return UserModule.IsLoggedIn;
    }

    render(h: any) {
	    return this.$slots.default;
    }

    async OnLogin() {
	    UserModule.GetVoteSites();
	    UserModule.GetVoteTimers();
    }

    async OnLogout() {
	    await dispatchActionForAllModules('Clear');
    }

    async OnLoginRequired(to?: string) {
	    if (this.isLoggedIn) return;
        this.$bvModal.show(ModalConstants.Login);
    }

    RealmRequired() {
	    if (!this.isLoggedIn) return;

	    this.$bvModal.show(ModalConstants.SelectRealm);
    }

    ReloadSite(hard: boolean = true) {
	    this.$bvToast.toast('There has been deployed a new website version. The website will reload shortly to apply the new updates.', {
	        title: 'Website Update',
	        variant: 'primary',
	        solid: true,
	        autoHideDelay: 5000,
	        noCloseButton: true
	    });
	    setTimeout(() => window.location.reload(hard), 5000);
    }

    UpdateUserSessions(data: { connection: ISignalRClient; lost: boolean }) {
	    if (data.connection.ipAddress === UserModule.activeIp) return;

	    const date = !data.lost ? dateFormat(data.connection.connected) : dateFormat(new Date());
	    const message = !data.lost
	        ? `Another user has logged into this account.\n\nIpAddress: ${data.connection.ipAddress}.`
	        : `Another user has logged out of this account.\n\nIpAddress: ${data.connection.ipAddress}`;

	    this.$bvToast.toast(message, {
	        title: `Login Notification ${date}`,
	        variant: 'warning',
	        solid: true,
	        autoHideDelay: 10000
	    });
    }

    NotificationReceived(notificaiton: NotificationViewObject) {
	    this.$bvToast.toast(notificaiton.message, {
	        title: 'Notification',
	        variant: 'primary',
	        solid: true,
	        autoHideDelay: 3000
	    });
    }

    HandleErrorMessages(newMessages: ClientMessage[]): void {
        newMessages.forEach(msg => {
            this.$bvToast.toast(msg.message || 'Error', {
                variant: 'danger',
                solid: true,
                title: ClientMessageType[msg.messageType] ?? 'Error'
            });
        });
    }

    handleVoteSuccess(site: VoteSiteViewObject) {
	    this.$bvToast.toast(`Succesfully voted for ${site.name}! You have been rewarded ${site.value} VP!`, {
	            title: 'Success',
	            variant: 'success',
	            solid: true
	        });
    }

    created() {
	    bus.on(BusConstants.OnLogin, this.OnLogin);
	    bus.on(BusConstants.OnLogout, this.OnLogout);
	    bus.on(BusConstants.LoginRequired, this.OnLoginRequired);
	    bus.on(BusConstants.RealmRequired, this.RealmRequired);
	    bus.on(BusConstants.ReloadWebsite, this.ReloadSite);
	    bus.on(BusConstants.UpdateUserSessions, this.UpdateUserSessions);
	    bus.on(BusConstants.NotificationReceived, this.NotificationReceived);
        bus.on(BusConstants.GeneralErrorEventKey, this.HandleErrorMessages);
	    bus.on(BusConstants.VoteSuccess, this.handleVoteSuccess);

	    this.$root.$on('bv::modal::shown', (bvEvent: BvModalEvent, modalId: ModalConstants) => {
	        if (!isModal(modalId)) return;

	        UrlService.setQueryParam('modals', [modalId]);
	    });

	    this.$root.$on('bv::modal::hidden', (bvEvent: BvModalEvent, modalId: ModalConstants) => {
	        if (!isModal(modalId)) return;

	        UrlService.removeQueryParam('modals', [modalId]);
	    });
    }

    beforeDestroy() {
	    bus.off(BusConstants.OnLogin, this.OnLogin);
	    bus.off(BusConstants.OnLogout, this.OnLogout);
	    bus.off(BusConstants.LoginRequired, this.OnLoginRequired);
	    bus.off(BusConstants.RealmRequired, this.RealmRequired);
	    bus.off(BusConstants.ReloadWebsite, this.ReloadSite);
	    bus.off(BusConstants.UpdateUserSessions, this.UpdateUserSessions);
        bus.off(BusConstants.NotificationReceived, this.NotificationReceived);
        bus.off(BusConstants.GeneralErrorEventKey, this.HandleErrorMessages);
	    bus.off(BusConstants.VoteSuccess, this.handleVoteSuccess);
    }
}
